<aside class="wrapper-satellite-lock-form">
  <div class="col-md-12">
    <div class="row px-0 px-sm-4">
      <div class="col-md-12 wrapper-detail">
        <div class="form-container" *ngIf="satelliteLock">
          <form [formGroup]="satelliteLockForm" (ngSubmit)="onSubmit()">
            <div class="container-card-row mt-4">
              <div class="form-fields-container">
                <div class="row">
                  <div class="col-md-6">
                    <div class="field-container">
                      <label class="imei-label">IMEI del dispositivo</label>
                      <div class="imei-value">{{ satelliteLock?.imei || '-' }}</div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="field-container">
                      <ng-container *ngIf="!isReadOnlyMode; else readOnlyConsecutive">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>Consecutivo Externo<span class="asterisk">*</span></mat-label>
                          <input matInput formControlName="consecutive" placeholder="Ej: 0001" onlyNumbersInt>
                          <mat-error *ngIf="hasError('consecutive')">{{ getErrorMessage('consecutive') }}</mat-error>
                        </mat-form-field>
                      </ng-container>
                      <ng-template #readOnlyConsecutive>
                        <label class="imei-label">Consecutivo</label>
                        <div class="imei-value">{{ satelliteLockForm.get('consecutive')?.value || '-' }}</div>
                      </ng-template>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="field-container">
                      <ng-container *ngIf="!isReadOnlyMode; else readOnlyType">
                        <app-autocomplete-satellite-lock-type [options]="typeAutocompleteOptions"
                          [inputFormControl]="satelliteLockForm.get('type')" [validate]="typeValidate">
                        </app-autocomplete-satellite-lock-type>
                        <mat-error *ngIf="hasError('type')">{{ getErrorMessage('type') }}</mat-error>
                      </ng-container>
                      <ng-template #readOnlyType>
                        <label class="imei-label">Tipo de dispositivo</label>
                        <div class="imei-value">{{ satelliteLock?.type?.name || '-' }}</div>
                      </ng-template>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="field-container">
                      <ng-container *ngIf="!isReadOnlyMode; else readOnlyId">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>ID del dispositivo <span class="asterisk">*</span></mat-label>
                          <input matInput formControlName="id" placeholder="Ej: LOCK-001"
                            [pattern]="patterns.SATELLITE_LOCK_ID_FIRMWARE.source">
                          <mat-error *ngIf="hasError('id')">{{ getErrorMessage('id') }}</mat-error>
                        </mat-form-field>
                      </ng-container>
                      <ng-template #readOnlyId>
                        <label class="imei-label">ID del dispositivo <span *ngIf="!isReadOnlyMode"
                            class="asterisk">*</span></label>
                        <div class="imei-value">{{ satelliteLockForm.get('id')?.value || '-' }}</div>
                      </ng-template>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="field-container">
                      <ng-container *ngIf="!isReadOnlyMode; else readOnlyStateDevice">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>Estado del Dispositivo <span class="asterisk">*</span></mat-label>
                          <mat-select formControlName="stateDevice">
                            <mat-option *ngFor="let option of stateDeviceOptions" [value]="option.value">
                              {{ option.label }}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="hasError('stateDevice')">{{ getErrorMessage('stateDevice') }}</mat-error>
                        </mat-form-field>
                      </ng-container>
                      <ng-template #readOnlyStateDevice>
                        <label class="imei-label">Estado del Dispositivo <span *ngIf="!isReadOnlyMode"
                            class="asterisk">*</span></label>
                        <div class="imei-value">{{ getStateDeviceText() }}</div>
                      </ng-template>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="field-container">
                      <ng-container *ngIf="!isReadOnlyMode; else readOnlyDescription">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>Descripción <span *ngIf="isDescriptionEnabled"
                              class="asterisk">*</span></mat-label>
                          <input matInput formControlName="description"
                            placeholder="Indique el motivo del estado (ej. Mantenimiento)">
                          <mat-error *ngIf="hasError('description')">
                            {{ getErrorMessage('description') }}
                          </mat-error>
                        </mat-form-field>
                      </ng-container>
                      <ng-template #readOnlyDescription>
                        <label class="imei-label">Descripción</label>
                        <div class="imei-value">{{ satelliteLockForm.get('description')?.value || '-' }}</div>
                      </ng-template>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="field-container">
                      <ng-container *ngIf="!isReadOnlyMode; else readOnlyFirmware">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>Versión de Firmware <span class="optional">(opcional)</span></mat-label>
                          <input matInput formControlName="firmwareVersion" placeholder="Ej: 1.0.3"
                            [pattern]="patterns.SATELLITE_LOCK_ID_FIRMWARE.source">
                          <mat-error *ngIf="hasError('firmwareVersion')">
                            {{ getErrorMessage('firmwareVersion') }}
                          </mat-error>
                        </mat-form-field>
                      </ng-container>
                      <ng-template #readOnlyFirmware>
                        <label class="imei-label">Versión de Firmware <span *ngIf="!isReadOnlyMode"
                            class="asterisk">*</span></label>
                        <div class="imei-value">{{ satelliteLockForm.get('firmwareVersion')?.value || '-' }}</div>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <input #inputImage class="display-none" type="file" accept="image/*"
                    (change)="setInstanceFileStorage($event)">
                  <div class="field-container">
                    <ng-container *ngIf="!isReadOnlyMode; else readOnlyImage">
                      <mat-form-field appearance="standard" (click)="openWindowFile()" class="w-100 pointer">
                        <mat-label>Imagen del dispositivo</mat-label>
                        <input matInput type="text" readonly [formControl]="visualImage" placeholder="Adjuntar imagen">
                        <i class="fas fa-paperclip" matSuffix></i>
                      </mat-form-field>
                    </ng-container>
                    <ng-template #readOnlyImage>
                      <div class="imei-value">{{ visualImage.value || 'Sin imagen adjunta' }}</div>
                    </ng-template>
                  </div>

                  <div *ngIf="loadingImage" class="spinner-container">
                    <i class="fas fa-spinner fa-spin"></i> Cargando imagen...
                  </div>

                  <ng-container *ngIf="imageResource || errorLoadImage">
                    <app-previsualization-resources [resource]="imageResource" [errorLoadResource]="errorLoadImage">
                    </app-previsualization-resources>
                  </ng-container>
                </div>
              </div>

              <div class="d-flex flex-column flex-sm-row justify-content-end buttons-container mt-2">
                <button mat-raised-button type="button" (click)="onDeleteSatelliteLock(satelliteLock)"
                  *ngIf="permissionRole.hasPermission(permission.administration.module, permission.administration.deleteSatelliteLock)"
                  class="button-delete mb-2 mb-sm-0"> Eliminar </button>

                <button mat-raised-button type="submit" color="primary"
                  *ngIf="permissionRole.hasPermission(permission.administration.module, permission.administration.updateSatelliteLock)"
                  [disabled]="loadingImage" class="bg-color-primary ml-sm-2"> Actualizar
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</aside>